import React, { useContext } from 'react'
import { userContext } from 'global/context/sub-contexts/userContext'
import { Link, navigate } from 'gatsby'

import * as styles from './ProfileDropdown.module.scss'

const ProfileDropdown = () => {
  const user_context = useContext(userContext)
  const { isLoggedIn, userPoints, getProfile } = useContext(userContext)

  const profileNameInitials = () => {
    let profile = getProfile()
    let { firstName, lastName } = profile
    let initials = 'CP'
    try {
      initials = firstName.charAt(0) + lastName.charAt(0)
    } catch (err) {}
    return initials
  }

  return (
    <div className={styles.profileContainer}>
      <Link to="/profile" className={styles.userAvatar}>
        {profileNameInitials()}
      </Link>
    </div>
  )
}

export default ProfileDropdown
